import { WcTextField, WcTextFieldProps } from "@bpipartners/webui";
import { AppContext } from "@patron/utils/context";
import { parsePhoneNumberWithError } from "libphonenumber-js";
import { useTranslations } from "next-intl";
import React from "react";

export const PhoneComponent = ({
  value,
  onCustomChange,
  ...rest
}: { value: string; onCustomChange?: (number: string) => void } & WcTextFieldProps) => {
  const { localAppState } = React.useContext(AppContext);
  const { defaultAddressCountry } = localAppState.tenantCompanyDetails.config.global;

  const t = useTranslations();
  const [hasParsingError, setHasParsingError] = React.useState(false);

  React.useEffect(() => {
    if (!value?.trim()) {
      setHasParsingError(false);
      return;
    }

    try {
      parsePhoneNumberWithError(
        value,
        defaultAddressCountry && defaultAddressCountry !== undefined ? defaultAddressCountry : "NL",
      );
      setHasParsingError(false);
    } catch {
      setHasParsingError(true);
    }
  }, [value, defaultAddressCountry]);

  const handleNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onCustomChange?.(event.target.value);
  };

  return (
    <WcTextField
      {...rest}
      value={value ?? ""}
      onChange={handleNumberChange}
      error={hasParsingError}
      helperText={hasParsingError ? t("labels.invalidPhoneNumber") : undefined}
    />
  );
};

export default PhoneComponent;
